import React from "react";

import { Chevron, Code } from "@packages/ds";
import { useIntl } from "react-intl";

import * as Dropdown from "ds/Dropdown";
import { capitalize } from "Libs/utils";
import Link from "src/tickets/common/components/Link";

import * as S from "./styles";

const TunnelDropdownButton = () => {
  const intl = useIntl();
  const formatMessage = useIntl().formatMessage;

  return (
    <S.Layout aria-label="Environment buttons">
      <S.Wrapper className="info-buttons">
        <Dropdown.Root>
          <Dropdown.Trigger variant="outline">
            {capitalize(intl.formatMessage({ id: "tunnel" }))} <Chevron />
          </Dropdown.Trigger>
          <Dropdown.Portal>
            <S.Content align="end">
              <S.MessageContainer>
                <S.Message>
                  {capitalize(
                    intl.formatMessage({ id: "tether_your_service_data" })
                  )}
                  <Link
                    href={formatMessage({ id: "links.CLI_repository" })}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {`${capitalize(formatMessage({ id: "CLI_command_name" }))} CLI`}
                  </Link>
                </S.Message>
                <S.Message>
                  <Link
                    href={formatMessage({ id: "links.documentation.tether" })}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {capitalize(formatMessage({ id: "learnmore" }))}
                  </Link>
                </S.Message>
              </S.MessageContainer>

              <Code.Block singleLine isCopyable id="cli_cmd">
                {`${formatMessage({ id: "CLI_command_name" })} tunnel:open`}
              </Code.Block>
            </S.Content>
          </Dropdown.Portal>
        </Dropdown.Root>
      </S.Wrapper>
    </S.Layout>
  );
};

export default TunnelDropdownButton;
